export default {
    okmain:{
      lang:"中文(繁体)",
      openkylinweburl:'https://www.openkylin.top/index-zh.html',
      openkylinsigurl:'https://www.openkylin.top/sig/application-zh.html',
      openkylinmemberurl:'https://www.openkylin.top/community/partner-zh.html',
      nav1:"數據總覽",
      nav2:"社區貢獻",
      nav3:"返回官網",
      user:"用戶 Users",
      deploy: "部署量 Deployments",
      nav_sig: "SIG興趣小組貢獻",
      nav_member: "單位成員貢獻",
      nav_number: "個人成員貢獻",
      contributors:"貢獻者 Contributors",
      member:"社區會員 Members",
      sig:"特別興趣小組 SIG",
      repositories:"代碼倉庫 Repositories",
      commits:"提交請求 Commits",
      pr:"合並請求 PR",
      issues:"需求&問題 Issues",
      code_lines: "代碼行數",
      f_copyright:"Copyright©2023 openKylin 所有權 京ICP备2020036654号-21",
      f_garight:"京公网安备11030102011760号",
      f_code:"代碼倉庫",
      f_joinmember:"加入會員",
      f_joinsig:"加入SIG",
      f_updatetime:"更新時間",
      f_frequency:"頻率",
      f_times:"小時一次",
      c_devel_contribute:"開發者貢獻",
      c_member_contribute:"單位成員貢獻",
      c_sig_contribute:"SIG興趣小組貢獻",
      c_time1:'一個月內',
      c_time2:'半年內',
      c_time3:'一年內',
      c_all:'全部',
      c_metrics:'度量指標',
      c_time: "時間長度",
      c_points:'積分',
      c_range:'顯示範圍',
      c_sort:'排序',
      c_giteename:"Gitee名",
      c_membername:"成員名稱",
      c_signame:"SIG名稱",
      c_communityname:"社區名",
      c_contributionvalue:"貢獻值",
      c_pointvalue:"積分值",



    }
  };



// WEBPACK FOOTER //
// ./src/local/language/zh.js